<template>
  <div class="main-wrap catering">
    <el-tabs v-model="activeName" @tab-click="handleClick" class="custom-catering">
      <el-tab-pane label="館內" name="first">
        <div class="container">
          <cateringList v-if="activeName == 'first'"  :activeName="activeName"></cateringList>
        </div>
      </el-tab-pane>
      <el-tab-pane label="試吃" name="second">
        <div class="container">
          <cateringList  v-if="activeName == 'second'" :activeName="activeName"></cateringList>
        </div>
      </el-tab-pane>
      <el-tab-pane label="院外" name="third">
        <div class="container">
          <cateringList v-if="activeName == 'third'" :activeName="activeName"></cateringList>
        </div>
      </el-tab-pane>
      <el-tab-pane label="陪宿" name="fourth">
        <div class="container">
          <cateringList v-if="activeName == 'fourth'" :activeName="activeName"></cateringList>
        </div>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
import cateringList from "@/components/CateringList.vue";
export default {
  name: "Catering",
  components: {
    cateringList,
  },
  data() {
    return {
      activeName: 'first'
    }
  },
  created() {

  },
  mounted() {
    if(this.$route.query.activeName){
      this.activeName = this.$route.query.activeName
    }
  },
  beforeDestroy() {
  },
  methods:{
    handleClick(tab, event) {
      console.log(tab, event);
    }
  }
};
</script>

<style lang="scss" scoped>
.home {

}
</style>
